import type { SVGProps } from 'react';
const DawnFlagMU = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MU_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MU_svg__a)">
      <path fill="#1DBB63" d="M0 16h22v-3.2H0z" />
      <path fill="#222B82" d="M0 8.533h22V4.267H0z" />
      <path fill="#FFD741" d="M0 12.8h22V8.533H0z" />
      <path fill="#F4374A" d="M0 4.267h22V0H0z" />
    </g>
  </svg>
);
export default DawnFlagMU;
